module.exports = __webpack_public_path__ + "static/media/logo-nd.f8bace94.png";